import React, { useState, useEffect } from 'react';
import './App.css';
import { AuthProvider } from './contexts/auth';
import { PermissionsProvider } from './contexts/permissionsContext';
import RouteApp from './routes/routes';
import { Toaster } from './shared/components/ui/sonner';
import { SWUpdatePrompt } from './shared/components/ui/sw-update-prompt';

function App() {
  const [swRegistration, setSwRegistration] = useState(null);

  useEffect(() => {
    const handleSwUpdate = (event) => {
      setSwRegistration(event.detail);
    };
    window.addEventListener('sw-update', handleSwUpdate);
    return () => window.removeEventListener('sw-update', handleSwUpdate);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <PermissionsProvider>
          <RouteApp />
        </PermissionsProvider>
      </AuthProvider>
      <Toaster richColors position="top-center" />
      {swRegistration && <SWUpdatePrompt registration={swRegistration} />}
    </div>
  );
}

export default App;
